import { useAuthenticationService } from '@pn/services/authentication';
import React from 'react';
import { activityMapURL } from 'src/ui/pages';

export function AuthRedirect({ type }: { type: 'signup' | 'login' }) {
  const { login } = useAuthenticationService();
  React.useEffect(
    () => login({ type, returnTo: activityMapURL }),
    [type, login]
  );
  return <></>;
}
